import React, {useCallback, useState} from "react";
import UserImagePopUpWrapper from "./UserImagePopUpWrapper";
import {UserImageMesageDiv} from "./styled";
import ImageSelectorInput from "./ImageSelectorInput";
import {Button} from "../../HTMLEntities/Button";
import {useDispatch} from "react-redux";
import {setIsLoading, setLoader, updateUserImage} from "../../Layout/actions";
import {REMOVE_USER_IMAGE} from "../../Layout/types";
import {getRequest} from "../../../utils/request";
import APIConfig from "../../../config/apiConfig";
import {ResponseFormat} from "../../../types";
import {updateUserImageField} from "../../../containers/RegistrationLoginPage/actions";
import {USER_DEFAULT_AVTAR_URL} from "../../../containers/RegistrationLoginPage/utils";
import {RUNTIME_ERROR} from "../../../containers/RegistrationLoginPage/errorUtils";
import UserImageErrorLayer from "./UserImageErrorLayer";

interface Props {
    setShowRemovePopUp: React.Dispatch<React.SetStateAction<boolean>>;
    removeChangeInputRef: React.MutableRefObject<HTMLInputElement | null>;
    removeChangePhotoHandle: (url: string) => void;
    onRemoveImage?: () => void;
    enableUserImageUpload: boolean;
}
const ChangeRemoveLayer: React.FC<Props> = ({
    setShowRemovePopUp,
    removeChangeInputRef,
    removeChangePhotoHandle,
    onRemoveImage,
    enableUserImageUpload = true,
}) => {
    const dispatch = useDispatch();
    const [errorMsg, setErrorMsg] = useState<string | null>(null);

    const proceedWithRemove = useCallback(async () => {
        try {
            if (enableUserImageUpload) {
                dispatch(setIsLoading(true));
                dispatch(setLoader(REMOVE_USER_IMAGE));
                const response = (await getRequest(APIConfig.REMOVE_USER_IMAGE)) as ResponseFormat<
                    boolean
                >;
                onRemoveImage && onRemoveImage();
                if (response.data?.data) {
                    dispatch(setIsLoading(false));
                    dispatch(setLoader(null));
                    dispatch(updateUserImageField(null));
                    dispatch(updateUserImage(USER_DEFAULT_AVTAR_URL));
                    setShowRemovePopUp(false);
                    return;
                }
            } else {
                onRemoveImage && onRemoveImage();
                setShowRemovePopUp(false);
                return;
            }
        } catch (error) {
            console.log(error);
        }

        onRemoveImage && onRemoveImage();
        setErrorMsg(`${RUNTIME_ERROR}[E007]`);
        dispatch(setIsLoading(false));
        dispatch(setLoader(null));
    }, [dispatch, setShowRemovePopUp, onRemoveImage, enableUserImageUpload]);

    return (
        <>
            <UserImagePopUpWrapper
                show={true}
                enableCross={true}
                closeHandle={() => {
                    setShowRemovePopUp(false);
                }}
                popUpName={"changeRemovePopUp"}
            >
                <UserImageMesageDiv>
                    <p>Do you want to remove this photo?</p>
                    <ImageSelectorInput
                        id="removeChangePhoto"
                        heading="Change Photo"
                        type="button"
                        ref={removeChangeInputRef}
                        onChange={removeChangePhotoHandle}
                    />
                    <Button
                        orange
                        onClick={proceedWithRemove}
                        buttonCSS={{
                            mobile: {width: "142px"},
                            laptop: {width: "142px"},
                        }}
                    >
                        Yes
                    </Button>
                </UserImageMesageDiv>
            </UserImagePopUpWrapper>
            {errorMsg && <UserImageErrorLayer errorMsg={errorMsg} setErrorMsg={setErrorMsg} />}
        </>
    );
};

export default ChangeRemoveLayer;
